import { render, staticRenderFns } from "./view.vue?vue&type=template&id=668c3c86&scoped=true&"
import script from "./view.vue?vue&type=script&lang=js&"
export * from "./view.vue?vue&type=script&lang=js&"
import style0 from "./view.vue?vue&type=style&index=0&lang=less&"
import style1 from "./view.vue?vue&type=style&index=1&id=668c3c86&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668c3c86",
  null
  
)

export default component.exports